// ============================================================
// mascotMessages.js — Calestan Mascot Message System
// ============================================================
// NIVEAUX UTILISATEUR :
//  debutant  : niveaux 1 à 9
//  avance    : niveaux 10 à 29 (premium)
//  expert    : niveux 30 à 50 (premium)
//
// PRIORITÉ D'AFFICHAGE :
//  1. Tabata bonus semaine (si toutes séances muscu validées + Tabata pas encore fait cette semaine)
//  2. Première connexion absolue
//  3. Nouvelle médaille débloquée (y compris post-Tabata validé)
//  4. Première séance ever
//  5. Nouveau PR
//  6. Semaine complétée
//  6.5. Tonnage +5% OU stagnation (4x même séance ±5%)
//  7. Séance du jour / Séance enregistrée ce jour
//  Puis : streak 7j, streak 30j, retour après absence, première connexion semaine
// ============================================================

// ------------------------------------------------------------
// HELPERS
// ------------------------------------------------------------
const pick = (arr) => arr[Math.floor(Math.random() * arr.length)];

const fmt = (msg, prenom, exercice, vars = {}) => {
  let result = msg
    .replace(/\[Prénom\]/g, prenom || "")
    .replace(/\[exercice\]/g, exercice || "");
  Object.entries(vars).forEach(([k, v]) => {
    result = result.replace(new RegExp(`\\[${k}\\]`, "g"), v ?? "");
  });
  return result;
};

// ------------------------------------------------------------
// MESSAGES PAR CATÉGORIE
// ------------------------------------------------------------

export const MASCOT_MESSAGES = {

  // 1. Première connexion absolue — fixe, jamais aléatoire
  firstConnectionEver: [
    "Bienvenue [Prénom] ! Swipe vers la gauche pour accéder à ton programme généré ou créer ton propre programme.",
  ],

  // 2. Première séance ever
  firstSessionEver: [
    "C'est ta première séance [Prénom], chaque champion a eu un premier jour. Le tien c'est aujourd'hui.",
    "Tout commence par une première séance. Tu viens de franchir le pas le plus important.",
    "Premier entraînement [Prénom]. Dans quelques semaines tu regarderas en arrière et tu seras fier d'avoir commencé.",
    "La première séance est toujours la plus dure. Tu l'as faite, le reste suivra.",
    "[Prénom], aujourd'hui tu poses la première pierre. Construis quelque chose de solide.",
    "Première séance enregistrée. C'est ici que tout commence.",
    "Tu aurais pu rester sur le canapé. Tu ne l'as pas fait. C'est ça qui fait la différence.",
    "Premier entraînement coché. La régularité fera le reste.",
    "[Prénom], le plus difficile c'était de commencer. C'est fait.",
    "Une première séance, un premier pas vers la meilleure version de toi-même.",
  ],

  // 3a. Retour après 2-4 jours d'absence (repos normal)
  returnAfter2to4Days: {
    debutant: [
      "Content de te revoir [Prénom], ton programme t'attendait.",
      "De retour [Prénom]. Quelques jours de repos et on repart plus fort.",
      "Te revoilà [Prénom]. Le corps se reconstruit au repos, maintenant il est temps de le solliciter.",
      "[Prénom], la pause c'est fait, place au travail.",
      "Retour aux affaires [Prénom]. On reprend là où on s'était arrêté.",
      "La récupération c'est important, mais là on est prêt à repartir.",
      "[Prénom], le repos fait partie du programme. Maintenant on remet les gaz.",
      "De retour [Prénom]. Ton corps a récupéré, il n'attend plus que toi.",
      "Petite pause terminée [Prénom]. On repart avec de l'énergie.",
      "Repos fait, muscles rechargés [Prénom]. C'est parti.",
    ],
    avance: [
      "Content de te revoir [Prénom]. À [N] séances, le repos fait vraiment partie du protocole.",
      "[Prénom], de retour. Quelques jours de récupération à ce stade, c'est du travail aussi.",
      "Te revoilà [Prénom]. À [N] entraînements, tu sais que le repos construit autant que la séance.",
      "[Prénom], pause terminée. Le corps a récupéré, maintenant on exploite cette fraîcheur.",
      "Retour [Prénom]. À [N] séances, tu connais ton corps — il est prêt.",
      "[Prénom], quelques jours de repos bien mérités. Maintenant on remet en route sérieusement.",
      "De retour [Prénom]. La récupération à ce niveau n'est pas de la flemme — c'est de la stratégie.",
      "[Prénom], repos fait. À [N] entraînements, tu sais exactement ce que ce repos va produire.",
      "Te revoilà [Prénom]. Le corps s'est reconstruit, les muscles sont frais — profite-en.",
      "[Prénom], retour après repos. À ce stade de ta progression, chaque séance post-récup est une opportunité.",
    ],
    expert: [
      "[Prénom], de retour. À [N] séances, tu sais mieux que quiconque ce que quelques jours de repos font au corps.",
      "Te revoilà [Prénom]. La récupération à ton niveau est une arme — tu viens de l'utiliser.",
      "[Prénom], pause terminée. [N] entraînements t'ont appris que le repos fait partie de la performance.",
      "Retour [Prénom]. À [N] séances, le corps récupéré c'est une puissance en réserve — exploite-la.",
      "[Prénom], quelques jours de repos. L'ours sait que tu reviendras plus fort — c'est toujours le cas.",
      "De retour [Prénom]. À [N] entraînements, chaque retour après repos est une séance de qualité garantie.",
      "[Prénom], repos bien mérité. Maintenant le corps est prêt à exprimer tout ce qu'il a absorbé.",
      "Te revoilà [Prénom]. [N] séances t'ont appris à écouter ton corps — et il est prêt maintenant.",
      "[Prénom], retour après récupération. L'ours reconnaît en toi quelqu'un qui sait gérer sa progression.",
      "De retour [Prénom]. À [N] séances, le retour après repos n'est plus une reprise — c'est une continuation.",
    ],
  },

  // 3b. Retour après 5-7 jours d'absence
  returnAfter5to7Days: {
    debutant: [
      "[Prénom], une semaine sans entraîner c'est long. Mais te voilà, c'est ce qui compte.",
      "Presque une semaine [Prénom]. Le corps a récupéré, maintenant on remet en route.",
      "[Prénom], longue pause. Pas de jugement — on repart doucement mais sûrement.",
      "5 à 7 jours sans séance [Prénom]. La reprise sera plus dure, mais tu as déjà fait le plus difficile : revenir.",
      "[Prénom], la vie prend parfois le dessus. L'essentiel c'est d'être là aujourd'hui.",
      "Retour après quelques jours [Prénom]. On y va à ton rythme.",
      "[Prénom], le repos c'est fait. Maintenant le corps est prêt. On y va.",
      "La reprise commence toujours par un premier pas [Prénom]. Tu l'as fait.",
      "[Prénom], on ne repart pas de zéro. On repart avec tout ce que tu as déjà construit.",
      "Retour en salle [Prénom]. On reprend là où on s'était arrêté.",
    ],
    avance: [
      "[Prénom], longue pause. À [N] séances, tu sais que la reprise sera exigeante — et tu reviens quand même.",
      "Te revoilà [Prénom]. Une semaine d'absence à ce stade, ça arrive. L'important c'est le retour.",
      "[Prénom], absence remarquée. À [N] entraînements, tu sais comment reprendre intelligemment.",
      "Retour après une longue pause [Prénom]. Le corps a récupéré — maintenant on relance la machine.",
      "[Prénom], quelques jours de plus que prévu. À [N] séances, ça ne remet pas en cause ce que tu as construit.",
      "De retour [Prénom]. La pause était longue, mais à [N] entraînements le moteur redémarre vite.",
      "[Prénom], retour après absence. Tu sais que la première séance après une longue pause est toujours particulière.",
      "Te revoilà [Prénom]. [N] séances derrière toi — une semaine sans entraînement ne change pas ça.",
      "[Prénom], longue pause terminée. À ce niveau, le corps n'oublie pas — il attend juste le signal.",
      "Retour [Prénom]. À [N] séances, tu as les outils pour reprendre exactement là où tu t'es arrêté.",
    ],
    expert: [
      "[Prénom], longue pause. À [N] séances, l'ours sait que ça arrive même aux meilleurs — l'important c'est là.",
      "Te revoilà [Prénom]. Une semaine d'absence sur [N] entraînements — ça ne remet rien en question.",
      "[Prénom], retour après absence. À ce niveau d'expérience, tu sais exactement comment reprendre.",
      "Longue pause terminée [Prénom]. [N] séances de fondations — le corps sait ce qu'il doit faire.",
      "[Prénom], quelques jours de trop sans entraîner. Mais te voilà, et à [N] séances c'est tout ce qui compte.",
      "De retour [Prénom]. L'ours reconnaît en toi quelqu'un qui revient toujours — peu importe la durée.",
      "[Prénom], absence de quelques jours. À [N] entraînements, le corps récupère vite et répond fort.",
      "Te revoilà [Prénom]. [N] séances t'ont construit quelque chose que quelques jours ne peuvent pas défaire.",
      "[Prénom], retour après longue pause. L'ours admire ceux qui reviennent — tu en fais partie depuis [N] séances.",
      "Retour [Prénom]. À [N] séances, une absence ne fait qu'affûter l'envie de reprendre.",
    ],
  },

  // 4. Retour après plus d'une semaine
  returnAfter1Week: {
    debutant: [
      "[Prénom], ça faisait un moment. L'important c'est d'être là maintenant.",
      "Te revoilà [Prénom], tu es de retour et c'est tout ce qui compte.",
      "Une semaine c'est long, mais une séance suffit pour reprendre le rythme. Allons-y [Prénom].",
      "[Prénom], la vie prend parfois le dessus. L'essentiel c'est de revenir.",
      "Retour après une pause [Prénom]. On y va doucement mais sûrement.",
      "Tu es de retour [Prénom]. Pas de jugement, juste du travail.",
      "[Prénom], aujourd'hui c'est le bon jour pour reprendre. C'est toujours aujourd'hui.",
      "La reprise est toujours la plus dure. Mais tu es là, c'est le principal.",
      "[Prénom], on repart de zéro ? Non, on repart avec tout ce que tu as déjà construit.",
      "[Prénom], te revoilà. L'ours reprend sa route.",
    ],
    avance: [
      "[Prénom], une semaine sans entraîner. À [N] séances, tu sais que ça arrive — et tu reviens, c'est tout.",
      "Te revoilà [Prénom]. Une semaine c'est long, mais [N] entraînements ne s'effacent pas si vite.",
      "[Prénom], retour après une semaine. À ce stade, la reprise sera exigeante — vas-y intelligemment.",
      "Retour [Prénom]. Une semaine d'absence sur [N] séances — la fondation est là, on la réveille.",
      "[Prénom], absence d'une semaine. À [N] entraînements, tu as les ressources pour reprendre fort.",
      "De retour [Prénom]. La semaine est passée, mais à [N] séances le corps sait quoi faire.",
      "[Prénom], une semaine sans séance. Tu sais comment reprendre — doucement mais solidement.",
      "Te revoilà [Prénom]. [N] entraînements derrière toi — une semaine de pause ne change pas ça.",
      "[Prénom], retour après une semaine. À ce niveau, reprendre c'est renouer avec quelque chose de solide.",
      "Retour [Prénom]. À [N] séances, une semaine d'absence n'est qu'une parenthèse — on la ferme aujourd'hui.",
    ],
    expert: [
      "[Prénom], une semaine sans entraîner. L'ours sait que rien de ce que tu as construit en [N] séances ne disparaît.",
      "Te revoilà [Prénom]. Une semaine sur [N] entraînements — l'ours attendait ton retour.",
      "[Prénom], retour après une semaine. À [N] séances, le corps a une mémoire longue — elle va se réveiller vite.",
      "Retour [Prénom]. [N] entraînements ont forgé quelque chose de solide. Une semaine ne l'efface pas.",
      "[Prénom], absence d'une semaine. L'ours ne juge pas — il reconnaît quelqu'un qui revient toujours.",
      "De retour [Prénom]. À [N] séances, tu sais mieux que quiconque comment relancer la machine.",
      "[Prénom], une semaine sans séance. Ce que tu as construit en [N] entraînements t'attend intact.",
      "Te revoilà [Prénom]. L'ours admire ceux qui reviennent après une pause — tu le fais depuis [N] séances.",
      "[Prénom], retour après une semaine. À ce niveau d'expérience, la reprise est une formalité.",
      "Retour [Prénom]. [N] séances derrière toi — l'ours est content de te revoir sur le chemin.",
    ],
  },

  // 5. Première connexion de la semaine
  firstConnectionOfWeek: {
    debutant: [
      "Nouvelle semaine [Prénom], nouvelle opportunité de progresser.",
      "La semaine commence aujourd'hui [Prénom]. Pose les bases dès maintenant.",
      "[Prénom], une semaine de plus pour repousser tes limites. C'est parti.",
      "Semaine fraîche, muscles reposés [Prénom]. On attaque.",
      "[Prénom], ce que tu fais cette semaine définit tes résultats du mois.",
      "Nouvelle semaine [Prénom]. Les objectifs de la semaine dernière sont derrière, place aux nouveaux.",
      "[Prénom], chaque semaine est une page blanche. Écris quelque chose de bien.",
      "La semaine démarre [Prénom]. Donne le ton dès aujourd'hui.",
      "[Prénom], une bonne semaine commence par une première séance solide.",
    ],
    avance: [
      "Nouvelle semaine [Prénom]. À [N] séances, tu sais exactement comment la bien commencer.",
      "[Prénom], semaine fraîche. Le travail de la semaine dernière est posé — on construit dessus.",
      "Nouvelle semaine [Prénom]. À [N] entraînements, chaque semaine est une brique supplémentaire.",
      "[Prénom], la semaine commence. Tu sais ce que tu as à faire — au travail.",
      "Semaine qui démarre [Prénom]. À [N] séances, le rythme est bien installé. On le tient.",
      "[Prénom], nouvelle semaine. À ce stade, l'objectif est simple — être aussi régulier que les précédentes.",
      "La semaine repart [Prénom]. [N] séances de fondations derrière toi — on continue de construire.",
      "[Prénom], semaine fraîche, muscles récupérés. À [N] entraînements, tu sais exploiter cette fraîcheur.",
      "Nouvelle semaine [Prénom]. Ce que tu fais cette semaine s'ajoute à [N] séances de travail sérieux.",
      "[Prénom], la semaine commence. À ce niveau, chaque séance validée renforce quelque chose de durable.",
    ],
    expert: [
      "[Prénom], nouvelle semaine. À [N] séances, l'ours sait que tu vas la boucler comme les précédentes.",
      "Semaine fraîche [Prénom]. [N] entraînements derrière toi — chaque nouvelle semaine s'ajoute à une légende personnelle.",
      "[Prénom], la semaine repart. À [N] séances, le rythme n'est plus une question — c'est une certitude.",
      "Nouvelle semaine [Prénom]. L'ours reconnaît en toi quelqu'un qui arrive chaque semaine avec la même intention.",
      "[Prénom], semaine qui commence. À [N] entraînements, chaque nouvelle semaine est une confirmation de qui tu es.",
      "La semaine démarre [Prénom]. [N] séances ont construit une constance que peu atteignent — on la maintient.",
      "[Prénom], nouvelle semaine. L'ours attend de te voir la boucler — comme tu l'as fait [N] fois avant.",
      "Semaine fraîche [Prénom]. À [N] séances, tu n'as plus besoin de motivation — juste de toi-même.",
      "[Prénom], la semaine repart. [N] entraînements — chaque semaine supplémentaire renforce ce que tu as bâti.",
      "Nouvelle semaine [Prénom]. L'ours admire ceux qui reviennent semaine après semaine depuis [N] séances.",
    ],
  },

  // 6. Séances du jour par groupe musculaire
  sessionOfDay: {
    dos: {
      debutant: [
        "Séance dos aujourd'hui [Prénom]. On travaille le V.",
        "Tractions, rowing, tirage [Prénom]. Le dos c'est la fondation de tout.",
        "[Prénom], un dos fort c'est la base de tout. Force et prestance.",
        "Dos au programme [Prénom]. Les muscles qu'on ne voit pas sont souvent les plus importants.",
        "[Prénom], aujourd'hui on travaille ce que les autres voient quand tu t'éloignes.",
        "Séance dos [Prénom]. Chaque répétition construit quelque chose de solide.",
        "[Prénom], le dos c'est la moitié de ton corps. Traite-le comme tel.",
        "Tirage, rowing, soulevé [Prénom]. Grosse séance en perspective.",
        "[Prénom], un dos musclé c'est moins de douleurs, plus de force, plus de prestance.",
        "Séance dos aujourd'hui [Prénom]. On sculpte le V.",

        "Séance dos au programme [Prénom]. Le V se construit aujourd'hui.",
        "[Prénom], dos aujourd'hui. Tractions, rowing — on y va.",
        "Dos au programme [Prénom]. La fondation de toute ta silhouette.",
        "[Prénom], le dos c'est ce que les autres voient quand tu t'éloignes. On le travaille aujourd'hui.",
        "Séance dos [Prénom]. Prends le temps de bien t'échauffer.",
      ],
      avance: [
        "Séance dos [Prénom]. À [N] entraînements, tu sais exactement comment solliciter ce groupe.",
        "[Prénom], dos aujourd'hui. Les tractions et le rowing n'ont plus de secrets pour toi.",
        "Dos au programme [Prénom]. À ce stade, chaque répétition est consciente et maîtrisée.",
        "[Prénom], séance dos. Le V que tu construis depuis [N] séances commence à se voir.",
        "Dos au programme [Prénom]. Tu connais tes exercices, tu connais tes charges — attaque.",
        "[Prénom], dos aujourd'hui. À [N] séances, la connexion musculaire est là. Exploite-la.",
        "Séance dos [Prénom]. Tirage, rowing, tractions — tu maîtrises le travail maintenant.",
        "[Prénom], dos au programme. Amplitude complète sur chaque mouvement, tu le sais.",
        "Dos aujourd'hui [Prénom]. [N] séances de fondations solides — on continue de construire.",
        "[Prénom], séance dos. À ce niveau, c'est la qualité d'exécution qui fait la différence.",
      ],
      expert: [
        "[Prénom], dos aujourd'hui. À [N] séances, chaque mouvement est une expression de ce que tu as construit.",
        "Séance dos [Prénom]. L'ours reconnaît en toi quelqu'un qui sait vraiment travailler ce groupe.",
        "[Prénom], dos au programme. [N] entraînements ont façonné une maîtrise rare — exprime-la.",
        "Dos aujourd'hui [Prénom]. À ce niveau, chaque répétition est précise, consciente, efficace.",
        "[Prénom], séance dos. Le V que tu as construit en [N] séances parle de lui-même.",
        "Dos au programme [Prénom]. L'ours admire la solidité que tu as forgée séance après séance.",
        "[Prénom], dos aujourd'hui. À [N] entraînements, ce groupe n'a plus de secret pour toi.",
        "Séance dos [Prénom]. La fondation que tu portes depuis [N] séances — renforce-la encore.",
        "[Prénom], dos au programme. À ce niveau d'expérience, c'est la qualité qui prime toujours.",
        "Dos aujourd'hui [Prénom]. [N] séances de maîtrise — l'ours s'incline devant ce travail.",
      ],
    },
    pectoraux: {
      debutant: [
        "Pectoraux aujourd'hui [Prénom]. Le développé couché t'attend.",
        "[Prénom], séance poitrine. Ce que tout le monde remarque en premier.",
        "Pecs au programme [Prénom]. On s'échauffe bien et on attaque.",
        "[Prénom], aujourd'hui on travaille la cage thoracique. Amplitude complète.",
        "Séance pectoraux [Prénom]. Développé, écarté, dips — le trio gagnant.",
        "[Prénom], séance poitrine. On construit un torse solide.",
        "Poitrine au programme [Prénom]. Développé, écarté, on attaque.",
        "[Prénom], séance pecs. Chaque série rapproche du résultat.",
        "Développé couché [Prénom]. La séance préférée de beaucoup, la tienne aussi ?",
        "[Prénom], pectoraux aujourd'hui. On étire, on contracte, on progresse.",

        "[Prénom], séance poitrine aujourd'hui. Le développé couché t'attend.",
        "Pecs au programme [Prénom]. Amplitude complète sur chaque répétition.",
        "[Prénom], séance pectoraux. On construit un torse solide aujourd'hui.",
        "Poitrine au programme [Prénom]. Développé, écarté — séance complète en vue.",
        "[Prénom], séance poitrine. Amplitude complète, chaque répétition compte.",
      ],
      avance: [
        "Pectoraux [Prénom]. À [N] séances, tu sais comment contracter et étirer correctement.",
        "[Prénom], séance poitrine. Le développé n'a plus de secret pour toi — exploite chaque répétition.",
        "Pecs au programme [Prénom]. À ce stade, la technique est là. On pousse les charges.",
        "[Prénom], pectoraux aujourd'hui. [N] séances de travail sérieux se voient dans ce groupe musculaire.",
        "Séance poitrine [Prénom]. Tu connais tes limites et tu sais comment les repousser.",
        "[Prénom], pecs au programme. Amplitude complète, connexion musculaire — tu maîtrises.",
        "Pectoraux [Prénom]. À [N] entraînements, chaque série est une opportunité de progresser.",
        "[Prénom], séance poitrine. Le torse se construit répétition après répétition — continue.",
        "Pecs aujourd'hui [Prénom]. À ce stade, c'est la concentration sur le mouvement qui fait la différence.",
        "[Prénom], pectoraux au programme. [N] séances de régularité produisent exactement ce genre de résultat.",
      ],
      expert: [
        "[Prénom], pectoraux aujourd'hui. À [N] séances, chaque contraction est maîtrisée et consciente.",
        "Séance poitrine [Prénom]. L'ours reconnaît en toi quelqu'un qui sait vraiment développer ce groupe.",
        "[Prénom], pecs au programme. [N] entraînements ont construit une expertise rare — exprime-la.",
        "Pectoraux aujourd'hui [Prénom]. À ce niveau, l'amplitude et la contraction sont des réflexes.",
        "[Prénom], séance poitrine. Le torse que tu as construit en [N] séances impose naturellement.",
        "Pecs au programme [Prénom]. L'ours admire la puissance pectorale que tu as forgée.",
        "[Prénom], pectoraux aujourd'hui. À [N] entraînements, chaque série compte vraiment.",
        "Séance poitrine [Prénom]. [N] séances de travail sérieux — exprime toute cette puissance aujourd'hui.",
        "[Prénom], pecs au programme. À ton niveau d'expérience, chaque répétition est une œuvre.",
        "Pectoraux aujourd'hui [Prénom]. [N] séances — l'ours s'incline devant cette construction.",
      ],
    },
    biceps: {
      debutant: [
        "Biceps aujourd'hui [Prénom]. Le muscle que tout le monde veut, celui qui se mérite.",
        "[Prénom], curl au programme. Concentration et amplitude complète.",
        "Séance biceps [Prénom]. Lent à la descente, explosif à la montée.",
        "Biceps au programme [Prénom]. Chaque curl compte.",
        "[Prénom], séance bras aujourd'hui. On construit du volume.",
        "Curl, marteau, incliné [Prénom]. On attaque sous tous les angles.",
        "[Prénom], les biceps se voient quand tu es en tee-shirt.",
        "Séance biceps [Prénom]. Amplitude complète, pas de triche.",
        "[Prénom], aujourd'hui on sculpte le pic du biceps. En avant.",
        "[Prénom], séance bras. On pose les bases du volume.",

        "[Prénom], biceps au programme. Amplitude complète, pas de triche.",
        "Biceps [Prénom]. Lent à la descente, contrôlé à la montée.",
        "[Prénom], séance bras aujourd'hui. On construit du volume.",
        "Biceps au programme [Prénom]. Chaque répétition compte.",
        "[Prénom], aujourd'hui on sculpte les bras. En avant.",
      ],
      avance: [
        "Biceps [Prénom]. À [N] séances, tu sais exactement comment isoler et contracter.",
        "[Prénom], séance bras. Le curl n'est plus un mystère — amplitude complète, contraction maximale.",
        "Biceps au programme [Prénom]. À ce stade, la qualité prime sur la quantité.",
        "[Prénom], bras aujourd'hui. [N] séances t'ont appris comment vraiment travailler ce groupe.",
        "Séance biceps [Prénom]. Tu connais tes exercices, tu connais tes charges — au travail.",
        "[Prénom], biceps au programme. Lent à la descente — tu le sais, applique-le.",
        "Bras aujourd'hui [Prénom]. À [N] entraînements, la connexion musculaire est bien là.",
        "[Prénom], séance biceps. Le volume se construit avec la régularité — tu en es la preuve.",
        "Biceps [Prénom]. À [N] séances, chaque curl conscient compte plus que dix bâclés.",
        "[Prénom], bras au programme. La maîtrise technique que tu as acquise, exploite-la aujourd'hui.",
      ],
      expert: [
        "[Prénom], biceps aujourd'hui. À [N] séances, l'isolation et la contraction sont parfaitement maîtrisées.",
        "Séance bras [Prénom]. L'ours reconnaît en toi quelqu'un qui sait vraiment travailler les biceps.",
        "[Prénom], biceps au programme. [N] entraînements ont construit une technique irréprochable.",
        "Bras aujourd'hui [Prénom]. À ce niveau, chaque curl est précis, contrôlé, conscient.",
        "[Prénom], séance biceps. Le volume que tu as construit en [N] séances est le résultat d'un travail d'expert.",
        "Biceps au programme [Prénom]. L'ours admire la maîtrise technique que tu as développée.",
        "[Prénom], bras aujourd'hui. À [N] entraînements, chaque répétition a une intention précise.",
        "Séance biceps [Prénom]. [N] séances de travail conscient — exprime cette expertise aujourd'hui.",
        "[Prénom], biceps au programme. À ton niveau, la qualité d'exécution est une signature.",
        "Bras aujourd'hui [Prénom]. [N] séances — l'ours s'incline devant cette maîtrise.",
      ],
    },
    triceps: {
      debutant: [
        "Triceps aujourd'hui [Prénom]. Les deux tiers de ton bras, souvent les plus négligés.",
        "[Prénom], dips, barre au front, extensions — séance triceps en vue.",
        "Séance triceps [Prénom]. Tu veux des bras imposants ? C'est ici que ça se passe.",
        "[Prénom], les triceps font la masse du bras. On leur donne ce qu'ils méritent.",
        "Triceps au programme [Prénom]. Contraction maximale à chaque répétition.",
        "[Prénom], un bras complet passe par des triceps solides. Au travail.",
        "Extensions, dips, pushdown [Prénom]. On attaque les trois faisceaux.",
        "[Prénom], séance triceps. Le muscle qui donne du volume au bras.",
        "Triceps aujourd'hui [Prénom]. Souvent oubliés, toujours décisifs.",
        "[Prénom], on ne néglige pas les triceps. Surtout pas aujourd'hui.",

        "[Prénom], triceps aujourd'hui. Les deux tiers du bras — on les travaille bien.",
        "Séance triceps [Prénom]. Dips, extensions, pushdown — le trio gagnant.",
        "[Prénom], triceps au programme. Contraction maximale à chaque série.",
        "Triceps aujourd'hui [Prénom]. Souvent négligés, toujours décisifs.",
        "[Prénom], on attaque les triceps. Tu veux des bras imposants ? C'est ici.",
      ],
      avance: [
        "Triceps [Prénom]. À [N] séances, tu sais comment attaquer les trois faisceaux efficacement.",
        "[Prénom], séance triceps. Extensions, dips — tu maîtrises les mouvements maintenant.",
        "Triceps au programme [Prénom]. À ce stade, la contraction finale sur chaque rep fait toute la différence.",
        "[Prénom], triceps aujourd'hui. [N] séances de travail sérieux se voient dans le volume du bras.",
        "Séance triceps [Prénom]. Tu connais tes exercices, tu connais tes sensations — applique-les.",
        "[Prénom], triceps au programme. Les deux tiers du bras méritent toute ton attention.",
        "Triceps [Prénom]. À [N] entraînements, chaque répétition contrôlée construit quelque chose de solide.",
        "[Prénom], séance triceps. La connexion musculaire est là — concentre-toi sur chaque contraction.",
        "Triceps aujourd'hui [Prénom]. À ce niveau, c'est la qualité d'exécution qui fait progresser.",
        "[Prénom], triceps au programme. [N] séances de régularité — le bras complet se construit comme ça.",
      ],
      expert: [
        "[Prénom], triceps aujourd'hui. À [N] séances, les trois faisceaux n'ont plus aucun secret pour toi.",
        "Séance triceps [Prénom]. L'ours reconnaît en toi quelqu'un qui sait vraiment développer ce groupe.",
        "[Prénom], triceps au programme. [N] entraînements ont forgé une expertise technique rare.",
        "Triceps aujourd'hui [Prénom]. À ce niveau, chaque extension est précise et maximalement contractée.",
        "[Prénom], séance triceps. Le volume du bras que tu as construit en [N] séances parle de lui-même.",
        "Triceps au programme [Prénom]. L'ours admire la puissance que tu as développée sur ce groupe.",
        "[Prénom], triceps aujourd'hui. À [N] entraînements, chaque répétition est une expression de maîtrise.",
        "Séance triceps [Prénom]. [N] séances de travail conscient — attaque avec toute cette expertise.",
        "[Prénom], triceps au programme. À ton niveau, chaque série a une intention précise.",
        "Triceps aujourd'hui [Prénom]. [N] séances — l'ours s'incline devant cette construction.",
      ],
    },
    jambes: {
      debutant: [
        "Jambes aujourd'hui [Prénom]. La séance que beaucoup évitent, pas toi.",
        "[Prénom], squat, presse, fentes — la séance qui forge le caractère.",
        "Séance jambes [Prénom]. Le bas du corps c'est la moitié de tes muscles. Traite-les bien.",
        "[Prénom], les jambes ça fait mal, ça fatigue, et ça donne les meilleurs résultats.",
        "Jambes au programme [Prénom]. Pas de jour à sauter les jambes.",
        "[Prénom], une silhouette équilibrée passe par des jambes travaillées. En avant.",
        "Séance jambes [Prénom]. Les squats lourds construisent plus que des jambes.",
        "[Prénom], aujourd'hui on travaille le plus grand groupe musculaire du corps. Ça se mérite.",
        "Jambes [Prénom]. La séance la plus difficile de la semaine, et la plus gratifiante.",
        "[Prénom], séance jambes. La plus exigeante de la semaine, et la plus utile.",

        "[Prénom], séance jambes aujourd'hui. La plus dure de la semaine, et la plus gratifiante.",
        "Séance jambes [Prénom]. Le bas du corps mérite autant d'attention que le haut.",
        "[Prénom], jambes aujourd'hui. Squat, presse, fentes — la séance qui forge le caractère.",
        "Jambes au programme [Prénom]. La plus exigeante de la semaine, et la plus utile.",
        "[Prénom], pas de jambes skippées. On y va.",
      ],
      avance: [
        "Séance jambes [Prénom]. À [N] entraînements, tu sais ce que ça demande — et tu y vas quand même.",
        "[Prénom], jambes aujourd'hui. Le squat profond, la presse lourde — tu maîtrises le travail.",
        "Jambes au programme [Prénom]. À ce stade, la technique est solide. On pousse les charges.",
        "[Prénom], séance jambes. [N] séances de régularité se voient dans la puissance de tes appuis.",
        "Jambes [Prénom]. Tu sais que c'est la séance la plus exigeante — et tu es là quand même.",
        "[Prénom], jambes au programme. À [N] entraînements, le bas du corps répond bien. Exploite-le.",
        "Séance jambes [Prénom]. Amplitude complète, charges adaptées — tu connais le protocole.",
        "[Prénom], jambes aujourd'hui. La puissance générée ici se retrouve dans chaque autre mouvement.",
        "Jambes au programme [Prénom]. À ce niveau, chaque série pesante construit plus que des muscles.",
        "[Prénom], séance jambes. [N] séances ont forgé un bas du corps solide — on continue.",
      ],
      expert: [
        "[Prénom], jambes aujourd'hui. À [N] séances, tu sais exactement ce que cette séance va produire.",
        "Séance jambes [Prénom]. L'ours reconnaît en toi quelqu'un qui ne fuit jamais ce travail.",
        "[Prénom], jambes au programme. [N] entraînements ont construit une puissance rare dans les appuis.",
        "Jambes aujourd'hui [Prénom]. À ce niveau, le squat profond et lourd est une expression de force pure.",
        "[Prénom], séance jambes. La puissance que tu as construite en [N] séances est impressionnante.",
        "Jambes au programme [Prénom]. L'ours admire ceux qui ne sautent jamais cette séance — tu en fais partie.",
        "[Prénom], jambes aujourd'hui. À [N] entraînements, chaque série pesante a une valeur rare.",
        "Séance jambes [Prénom]. [N] séances de constance — le bas du corps que tu portes le prouve.",
        "[Prénom], jambes au programme. À ton niveau, cette séance révèle toute ton expérience.",
        "Jambes aujourd'hui [Prénom]. [N] séances — l'ours s'incline devant cette puissance construite.",
      ],
    },
    abdos: {
      debutant: [
        "Abdos aujourd'hui [Prénom]. Le gainage c'est la base de tout le reste.",
        "[Prénom], les abdos se font en cuisine et en salle. Aujourd'hui c'est la partie salle.",
        "Séance abdos [Prénom]. Planche, crunch, relevé de jambes — on attaque le core.",
        "[Prénom], un core solide améliore chaque autre exercice que tu fais.",
        "Abdos au programme [Prénom]. Focus sur la contraction, pas sur la vitesse.",
        "[Prénom], le core c'est le centre de gravité de toute ta performance.",
        "Séance abdos [Prénom]. On ne les voit peut-être pas encore, mais ils sont là.",
        "[Prénom], gainage, rotations, relevés — séance complète en vue.",
        "Abdos aujourd'hui [Prénom]. Lent et contrôlé, c'est comme ça que ça marche.",
        "[Prénom], les abdos ne se construisent pas en un jour. Mais chaque séance compte.",

        "[Prénom], abdos aujourd'hui. Le core c'est la base de tout.",
        "Séance abdos [Prénom]. Planche, relevés, rotations — on attaque le centre.",
        "[Prénom], core day. Un core solide améliore chaque autre exercice.",
        "Abdos au programme [Prénom]. Lent et contrôlé, c'est comme ça que ça marche.",
        "[Prénom], gainage aujourd'hui. On construit les fondations.",
      ],
      avance: [
        "Abdos [Prénom]. À [N] séances, tu sais que le core est la base de tout le reste.",
        "[Prénom], séance core aujourd'hui. La connexion avec le centre du corps est acquise — exploite-la.",
        "Abdos au programme [Prénom]. À ce stade, c'est la contraction consciente qui fait la différence.",
        "[Prénom], core aujourd'hui. [N] séances ont construit des fondations solides — on les renforce.",
        "Séance abdos [Prénom]. Tu sais comment contracter, comment respirer — applique-le.",
        "[Prénom], abdos au programme. Lent et contrôlé, tu maîtrises l'exécution maintenant.",
        "Core aujourd'hui [Prénom]. À [N] entraînements, chaque gainage conscient compte.",
        "[Prénom], séance abdos. La qualité du travail ici améliore tout le reste — tu le sais.",
        "Abdos [Prénom]. À ce niveau, la technique prime — concentre-toi sur chaque contraction.",
        "[Prénom], core au programme. [N] séances de travail sérieux construisent exactement ce genre de solidité.",
      ],
      expert: [
        "[Prénom], abdos aujourd'hui. À [N] séances, le gainage n'est plus un exercice — c'est une fondation.",
        "Séance core [Prénom]. L'ours reconnaît en toi quelqu'un qui comprend l'importance du centre.",
        "[Prénom], abdos au programme. [N] entraînements ont construit un core d'athlète — entretiens-le.",
        "Core aujourd'hui [Prénom]. À ce niveau, chaque gainage conscient améliore chaque autre mouvement.",
        "[Prénom], séance abdos. La solidité au centre que tu as construite en [N] séances est une base rare.",
        "Abdos au programme [Prénom]. L'ours admire ceux qui travaillent ce groupe avec autant de sérieux.",
        "[Prénom], core aujourd'hui. À [N] entraînements, chaque répétition contrôlée a une valeur réelle.",
        "Séance abdos [Prénom]. [N] séances de travail conscient — ce centre solide, c'est toi qui l'as construit.",
        "[Prénom], abdos au programme. À ton niveau, la qualité de chaque contraction fait toute la différence.",
        "Core aujourd'hui [Prénom]. [N] séances — l'ours s'incline devant cette fondation que tu as bâtie.",
      ],
    },
    epaules: {
      debutant: [
        "Séance épaules [Prénom]. Le muscle qui donne de la carrure.",
        "[Prénom], épaules aujourd'hui. Développé, élévations — on attaque les trois faisceaux.",
        "Épaules au programme [Prénom]. Un des groupes les plus visibles sous un tee-shirt.",
        "[Prénom], séance épaules. Concentre-toi sur la contraction à chaque répétition.",
        "Épaules [Prénom]. Les muscles qui définissent la largeur de tes épaules. On les travaille.",
        "[Prénom], développé militaire, élévations latérales — séance épaules en vue.",
        "Séance épaules [Prénom]. Un travail régulier ici transforme la silhouette.",
        "[Prénom], les épaules c'est le carrefour de beaucoup de mouvements. On les renforce.",
        "Épaules au programme [Prénom]. Trois faisceaux, une séance solide.",
        "[Prénom], séance épaules. La posture et la force commencent ici.",

        "[Prénom], épaules au programme. Le muscle qui donne de la carrure.",
        "Séance épaules [Prénom]. Développé, élévations latérales — on attaque les trois faisceaux.",
        "[Prénom], épaules aujourd'hui. Un des groupes les plus visibles sous un tee-shirt.",
        "Épaules au programme [Prénom]. Concentre-toi sur la contraction.",
        "[Prénom], séance épaules. On sculpte la silhouette.",
      ],
      avance: [
        "Épaules [Prénom]. À [N] séances, tu sais comment attaquer les trois faisceaux sans te blesser.",
        "[Prénom], séance épaules. Le développé militaire, les élévations — tu maîtrises les mouvements.",
        "Épaules au programme [Prénom]. À ce stade, la qualité d'exécution transforme les résultats.",
        "[Prénom], épaules aujourd'hui. [N] séances ont affiné ta technique — exploite-la.",
        "Séance épaules [Prénom]. La carrure se construit répétition après répétition — tu le sais.",
        "[Prénom], épaules au programme. Contraction maximale sur chaque rep — tu connais le travail.",
        "Épaules [Prénom]. À [N] entraînements, ce groupe musculaire répond bien. Pousse-le.",
        "[Prénom], séance épaules. Les faisceaux antérieur, latéral, postérieur — on attaque les trois.",
        "Épaules aujourd'hui [Prénom]. La posture et la force que tu as construites se voient maintenant.",
        "[Prénom], épaules au programme. [N] séances de régularité produisent exactement cette carrure.",
      ],
      expert: [
        "[Prénom], épaules aujourd'hui. À [N] séances, tu sais comment solliciter chaque faisceau précisément.",
        "Séance épaules [Prénom]. L'ours reconnaît en toi quelqu'un qui a vraiment développé ce groupe.",
        "[Prénom], épaules au programme. [N] entraînements ont construit une carrure qui s'impose naturellement.",
        "Épaules aujourd'hui [Prénom]. À ce niveau, chaque élévation consciente construit quelque chose de durable.",
        "[Prénom], séance épaules. La carrure que tu as construite en [N] séances parle d'elle-même.",
        "Épaules au programme [Prénom]. L'ours admire la largeur et la force que tu as développées.",
        "[Prénom], épaules aujourd'hui. À [N] entraînements, les trois faisceaux sont travaillés avec précision.",
        "Séance épaules [Prénom]. [N] séances de travail sérieux — exprime toute cette maîtrise aujourd'hui.",
        "[Prénom], épaules au programme. À ton niveau, chaque mouvement est une expression d'expertise.",
        "Épaules aujourd'hui [Prénom]. [N] séances — l'ours s'incline devant cette construction remarquable.",
      ],
    },
    fessiers: {
      debutant: [
        "Séance fessiers [Prénom]. Le groupe musculaire le plus puissant du corps.",
        "[Prénom], fessiers aujourd'hui. Amplitude complète sur chaque mouvement.",
        "Fessiers au programme [Prénom]. Hip thrust, squat, fentes — on y va.",
        "[Prénom], séance fessiers. Un des groupes les plus importants pour la posture et la force.",
        "Fessiers [Prénom]. Le travail d'aujourd'hui se verra dans quelques semaines.",
        "[Prénom], fessiers aujourd'hui. Pas de tricherie sur l'amplitude.",
        "Séance fessiers [Prénom]. Chaque répétition complète compte double.",
        "[Prénom], fessiers aujourd'hui. On construit de la puissance et de la silhouette.",
        "Fessiers au programme [Prénom]. Concentration sur la contraction en haut du mouvement.",
        "[Prénom], séance fessiers. Le bas du corps mérite autant d'attention que le haut.",

        "[Prénom], fessiers et jambes au programme. Hip thrust, squat — on y va.",
        "Séance fessiers [Prénom]. Le groupe musculaire le plus puissant du corps.",
        "[Prénom], fessiers aujourd'hui. Amplitude complète sur chaque mouvement.",
        "Fessiers au programme [Prénom]. Un des groupes les plus importants pour la posture.",
        "[Prénom], séance fessiers aujourd'hui. On ne la rate pas.",
      ],
      avance: [
        "Fessiers [Prénom]. À [N] séances, tu sais comment activer ce groupe correctement.",
        "[Prénom], séance fessiers. Hip thrust, squat profond — la technique est maîtrisée.",
        "Fessiers au programme [Prénom]. À ce stade, l'amplitude complète est un réflexe.",
        "[Prénom], fessiers aujourd'hui. [N] séances de travail sérieux se voient dans la puissance générée.",
        "Séance fessiers [Prénom]. Tu sais comment contracter en haut du mouvement — applique-le.",
        "[Prénom], fessiers au programme. Le groupe le plus puissant du corps mérite toute ton attention.",
        "Fessiers [Prénom]. À [N] entraînements, la connexion musculaire est bien là. Exploite-la.",
        "[Prénom], séance fessiers. La puissance construite ici se retrouve dans chaque autre exercice.",
        "Fessiers aujourd'hui [Prénom]. À ce niveau, chaque répétition complète compte vraiment.",
        "[Prénom], fessiers au programme. [N] séances ont construit quelque chose de solide — on continue.",
      ],
      expert: [
        "[Prénom], fessiers aujourd'hui. À [N] séances, l'activation et la contraction sont parfaitement maîtrisées.",
        "Séance fessiers [Prénom]. L'ours reconnaît en toi quelqu'un qui travaille ce groupe avec l'expertise qu'il mérite.",
        "[Prénom], fessiers au programme. [N] entraînements ont construit une puissance musculaire rare.",
        "Fessiers aujourd'hui [Prénom]. À ce niveau, chaque hip thrust est précis, profond, conscient.",
        "[Prénom], séance fessiers. La puissance que tu as construite en [N] séances est celle d'un athlète accompli.",
        "Fessiers au programme [Prénom]. L'ours admire la puissance et la maîtrise que tu as développées.",
        "[Prénom], fessiers aujourd'hui. À [N] entraînements, ce groupe révèle toute ton expérience.",
        "Séance fessiers [Prénom]. [N] séances de travail sérieux — attaque avec toute cette expertise.",
        "[Prénom], fessiers au programme. À ton niveau, l'amplitude complète est une évidence.",
        "Fessiers aujourd'hui [Prénom]. [N] séances — l'ours s'incline devant cette puissance construite.",
      ],
    },
  },

  // 7. Séance complétée
  sessionDone: {
    debutant: [
      "Séance terminée [Prénom]. C'est fait, personne ne peut te l'enlever.",
      "[Prénom], travail accompli. Ton corps va s'en souvenir.",
      "Séance terminée [Prénom]. Récupère bien, la progression se fait au repos.",
      "[Prénom], une séance de plus dans la construction. Chaque répétition compte.",
      "C'est coché [Prénom]. Maintenant laisse ton corps faire le travail.",
      "[Prénom], belle séance. Les résultats se construisent exactement comme ça.",
      "Séance complète [Prénom]. Mange bien, dors bien, reviens plus fort.",
      "[Prénom], tu t'es présenté et tu as fait le travail. C'est tout ce qu'on demande.",
      "Une de plus [Prénom]. La régularité bat toujours l'intensité sur le long terme.",
      "[Prénom], séance terminée. La version de demain te remerciera.",
    ],
    avance: [
      "Séance [N] [Prénom]. Le compteur tourne, le corps se transforme.",
      "[Prénom], encore une séance validée. À [N] entraînements, chaque effort s'accumule.",
      "Travail fait [Prénom]. [N] séances au compteur — tu n'es plus un débutant.",
      "[Prénom], séance terminée. À ce niveau, c'est la constance qui fait tout.",
      "Une de plus [Prénom]. [N] séances, c'est une fondation solide.",
      "[Prénom], [N] entraînements. Le corps s'est adapté, il en veut encore.",
      "Séance validée [Prénom]. À [N] sessions, les résultats ne sont plus un hasard.",
      "[Prénom], bien travaillé. [N] séances — le sérieux commence à se voir.",
      "C'est fait [Prénom]. [N] entraînements derrière toi, la progression est réelle.",
      "[Prénom], [N] séances. Tu commences à vraiment connaître ton corps.",
    ],
    expert: [
      "[Prénom], [N] séances. Tu fais partie de ceux qui restent quand les autres abandonnent.",
      "Séance [N] [Prénom]. À ce niveau, chaque entraînement est une preuve de ce que tu es.",
      "[Prénom], [N] entraînements. L'ours s'incline devant cette discipline.",
      "Encore une séance [Prénom]. [N] au total — une trajectoire que peu de gens atteignent.",
      "[Prénom], [N] séances. Ton corps te remercie de ne l'avoir jamais lâché.",
      "Travail accompli [Prénom]. [N] entraînements — c'est une vie d'athlète que tu construis.",
      "[Prénom], [N] séances. Les résultats que tu vois aujourd'hui, tu les as mérités répétition après répétition.",
      "Séance terminée [Prénom]. À [N] entraînements, tu appartiens à une catégorie rare.",
      "[Prénom], [N] sessions. Beaucoup rêvent de ce niveau de régularité — toi tu le vis.",
      "[Prénom], [N] séances. Ce chiffre raconte tout ce que les autres ne voient pas.",
    ],
  },

  // 8. Nouveau PR
  newPR: {
    debutant: [
      "Record battu [Prénom]. Ce que tu pensais être ton maximum ne l'était pas.",
      "[Prénom], nouveau PR sur [exercice]. Note-le bien, c'est ta nouvelle référence.",
      "[Prénom], tu viens de repousser tes limites. C'est exactement pour ça qu'on s'entraîne.",
      "PR [Prénom]. La progression ne ment jamais.",
      "[Prénom], [exercice] — nouveau record. Le travail paie toujours.",
      "Record personnel sur [exercice] [Prénom]. La barre est placée plus haut maintenant.",
      "[Prénom], nouveau PR. Souviens-toi de ce moment quand tu doutes de ta progression.",
      "Plus lourd, plus fort [Prénom]. Nouveau record sur [exercice].",
      "[Prénom], ton corps vient de prouver qu'il peut faire plus. Nouveau record sur [exercice].",
      "PR [Prénom]. Ce chiffre est le nouveau plancher, pas le plafond.",
    ],
    avance: [
      "[Prénom], PR sur [exercice]. À [N] séances, chaque record se mérite vraiment.",
      "Nouveau record sur [exercice] [Prénom]. Le travail accumulé finit toujours par payer.",
      "[Prénom], [exercice] — nouveau PR. La progression est réelle, les chiffres le prouvent.",
      "PR [Prénom]. À ce niveau les records ne tombent pas par hasard.",
      "[Prénom], nouveau record sur [exercice]. Tu repousses tes propres limites séance après séance.",
      "Record battu sur [exercice] [Prénom]. [N] séances de travail derrière ce chiffre.",
      "[Prénom], PR sur [exercice]. Le corps s'adapte, les charges montent — c'est la mécanique du progrès.",
      "Nouveau PR [Prénom]. Sur [exercice], tu viens de poser une nouvelle référence.",
      "[Prénom], [exercice] — record personnel. À [N] séances, les progrès sont concrets.",
      "PR sur [exercice] [Prénom]. Chaque kilo de plus représente des semaines de travail sérieux.",
    ],
    expert: [
      "[Prénom], PR sur [exercice] à [N] séances. Les records à ce niveau sont rares — savoure ce moment.",
      "Nouveau record sur [exercice] [Prénom]. Après tout ce chemin, chaque gramme de plus est exceptionnel.",
      "[Prénom], [exercice] — nouveau PR. À [N] entraînements, ce chiffre représente des mois de discipline.",
      "PR [Prénom]. Sur [exercice], tu viens de prouver que la progression n'a pas de plafond.",
      "[Prénom], record battu sur [exercice]. L'ours s'incline — ce genre de performance se mérite sur la durée.",
      "Nouveau record [Prénom]. [N] séances pour en arriver là — chaque répétition comptait.",
      "[Prénom], PR sur [exercice]. À ton niveau, chaque nouveau record est une victoire d'exception.",
      "Record personnel sur [exercice] [Prénom]. Ce que tu viens de faire, beaucoup ne l'atteindront jamais.",
      "[Prénom], [exercice] — PR. Après [N] entraînements, tu continues de repousser ce que tu pensais possible.",
      "Nouveau record sur [exercice] [Prénom]. L'élite se reconnaît à ce genre de moment.",
    ],
  },

  // 9. Fin de semaine / objectif atteint
  weekCompleted: {
    debutant: [
      "Semaine complète [Prénom]. Tu as fait ce que beaucoup n'ont pas fait cette semaine.",
      "[Prénom], toutes les séances cochées. C'est de la discipline, pas de la motivation.",
      "Semaine bouclée [Prénom]. Repose-toi ce weekend, tu l'as mérité.",
      "[Prénom], objectif semaine atteint. La régularité finit toujours par payer.",
      "Belle semaine [Prénom]. C'est exactement comme ça qu'on construit un physique.",
      "[Prénom], semaine terminée. Ce que tu as fait te rapproche de là où tu veux aller.",
      "Toutes les séances validées [Prénom]. Pas d'excuses, juste du travail.",
      "[Prénom], semaine accomplie. Profite du repos, le corps en a besoin autant que la salle.",
      "Objectif atteint [Prénom]. Même résultat la semaine prochaine ?",
      "[Prénom], semaine solide. Les meilleures transformations se construisent semaine après semaine.",
    ],
    avance: [
      "Semaine complète [Prénom]. À [N] séances au compteur, la discipline est ancrée.",
      "[Prénom], objectif semaine atteint. Semaine après semaine, tu construis quelque chose de sérieux.",
      "Toutes les séances validées [Prénom]. À [N] entraînements, c'est une habitude bien installée.",
      "[Prénom], semaine bouclée. Le corps progresse exactement parce que tu es régulier comme ça.",
      "Semaine terminée [Prénom]. [N] séances au total — la trajectoire est claire.",
      "[Prénom], objectif atteint encore une fois. À ce stade ce n'est plus un effort, c'est un réflexe.",
      "Belle semaine [Prénom]. [N] entraînements cumulés — chaque semaine complète compte double.",
      "[Prénom], toutes les séances cochées. La régularité à [N] sessions, c'est ce qui fait la différence.",
      "Semaine validée [Prénom]. Tu n'as pas besoin de motivation — tu as mieux, tu as la discipline.",
      "[Prénom], semaine accomplie. [N] séances derrière toi — continue exactement comme ça.",
    ],
    expert: [
      "[Prénom], semaine complète encore une fois. [N] séances au total — une constance que très peu atteignent.",
      "Objectif semaine atteint [Prénom]. À [N] entraînements, tu sais mieux que quiconque ce que ça représente.",
      "[Prénom], toutes les séances validées. [N] séances cumulées — l'ours reconnaît en toi un athlète d'exception.",
      "Semaine bouclée [Prénom]. Après [N] entraînements, cette constance te place dans une catégorie rare.",
      "[Prénom], semaine terminée. [N] séances au compteur — chaque semaine ajoutée à ce total est remarquable.",
      "Encore une semaine complète [Prénom]. À [N] entraînements, tu n'as plus rien à prouver — et pourtant tu continues.",
      "[Prénom], objectif atteint. [N] séances — les gens qui tiennent ce rythme aussi longtemps se comptent sur les doigts d'une main.",
      "Semaine validée [Prénom]. Ce que tu fais semaine après semaine depuis [N] séances, c'est exceptionnel.",
      "[Prénom], semaine accomplie. L'ours s'incline devant cette régularité sans faille.",
      "Toutes les séances cochées [Prénom]. [N] entraînements au total — une performance que l'ours admire.",
    ],
  },

  // 9b. Séance sautée cette semaine
  missedSession: [
    "[Prénom], tu n'as pas encore fait [séance] cette semaine. C'est la prochaine au programme.",
    "[Prénom], [séance] a été sautée cette semaine. On la rattrape aujourd'hui ?",
    "[Prénom], [séance] t'attend encore. On l'ajoute au programme de la journée ?",
    "[Prénom], il reste [séance] à faire cette semaine. L'ours note que tu ne l'as pas oubliée.",
    "[séance] manque au tableau de cette semaine [Prénom]. On y va ?",
    "[Prénom], [séance] n'a pas encore été cochée cette semaine. C'est maintenant.",
    "Cette semaine il manque encore [séance] [Prénom]. Le programme complet te donnera les meilleurs résultats.",
    "[Prénom], [séance] est en attente depuis quelques jours. On la fait aujourd'hui ?",
  ],

  // 10. Incitation Tabata
  tabataIncitation: [
    "[Prénom], programme de la semaine bouclé. Tu as de l'énergie en réserve ? Une session Tabata brûle les dernières calories.",
    "Toutes les séances cochées [Prénom]. Pour les plus motivés, le Tabata t'attend.",
    "[Prénom], objectif semaine atteint. Une session Tabata pour finir en beauté ?",
    "Programme terminé [Prénom]. Le Tabata c'est 20 minutes pour tout donner. Tu es partant ?",
    "[Prénom], tu as tout fait cette semaine. Le Tabata c'est le bonus pour ceux qui veulent aller plus loin.",
    "Semaine bouclée [Prénom]. Si tu veux pousser un peu plus, une session Tabata est là pour toi.",
    "[Prénom], programme complet. Le Tabata c'est optionnel, mais ceux qui le font ne le regrettent jamais.",
    "Tout coché [Prénom]. Une session Tabata pour transformer cette bonne semaine en excellente semaine ?",
    "[Prénom], tu as fait le travail prévu. Le Tabata c'est pour ceux qui refusent de s'arrêter là.",
    "Programme de la semaine terminé [Prénom]. Le Tabata t'attend si tu veux finir sur un effort intense.",
  ],

  // 11. Tabata bonus validé
  tabataBonusDone: [
    "[Prénom], tu as tout donné cette semaine. Muscu et Tabata — c'est une semaine de champion.",
    "Séances muscu + Tabata [Prénom]. Tout le monde n'a pas ce niveau de discipline.",
    "[Prénom], Tabata validé en plus de ta semaine complète. C'est ce genre de séances qui font la différence.",
    "Semaine de muscu bouclée et Tabata en prime [Prénom]. Tu repousses tes propres limites. Continue.",
    "[Prénom], muscu et Tabata dans la même semaine. Ce niveau de discipline est rare.",
    "Semaine complète + Tabata [Prénom]. Tu as fait ce que la plupart remettent à demain.",
    "[Prénom], le Tabata c'était optionnel. Tu l'as fait quand même. C'est ça la différence.",
    "Muscu + cardio intense [Prénom]. Ton corps va s'en souvenir cette semaine.",
    "[Prénom], certains font leurs séances. Toi tu fais tes séances et le bonus. Continue.",
    "Semaine muscu + Tabata [Prénom]. Le genre de semaine qui accélère les résultats.",
  ],

  // 12. Jour de repos
  restDay: [
    "[Prénom], semaine bouclée. Aujourd'hui c'est repos — les muscles se construisent en récupérant.",
    "Programme validé, Tabata compris. Laisse ton corps absorber le travail, [Prénom].",
    "Tu as fait le boulot cette semaine. Le repos c'est pas de la flemme, c'est de l'entraînement, [Prénom].",
    "Repos actif si tu veux : marche, étirements. Mais pas de fonte aujourd'hui, [Prénom].",
    "[Prénom], semaine complète + Tabata. Ton corps mérite cette pause. Profites-en vraiment.",
    "La récupération fait partie du plan [Prénom]. Muscu + Tabata cette semaine — aujourd'hui on laisse les fibres se reconstruire.",
  ],

  // 13. Streaks
  streak7Days: {
    debutant: [
      "[Prénom], 7 jours de suite. La régularité commence à devenir une habitude.",
      "Une semaine complète [Prénom]. Le rythme est là, on le garde.",
      "[Prénom], 7 jours consécutifs. Le corps s'adapte, la progression suit.",
      "[Prénom], 7 jours d'affilée. L'habitude se construit exactement comme ça.",
      "[Prénom], streak de 7 jours. Le plus dur était de commencer, maintenant on garde le rythme.",
      "7 jours [Prénom]. Ce n'est plus de la motivation, c'est une routine.",
      "[Prénom], 7 séances consécutives. Souviens-toi de ce chiffre quand tu auras des jours sans envie.",
      "7 jours de suite [Prénom]. La discipline est là, les résultats suivront.",
    ],
    avance: [
      "[Prénom], 7 jours de suite. À [N] séances, tu sais que la régularité n'est pas un hasard.",
      "Streak 7 jours [Prénom]. À ce stade de ta progression, c'est une confirmation de plus.",
      "[Prénom], 7 séances consécutives. Le corps et la tête fonctionnent en équipe maintenant.",
      "Une semaine d'affilée [Prénom]. À [N] entraînements, les habitudes sont solides.",
      "[Prénom], 7 jours sans interruption. La machine est bien huilée.",
      "Streak de 7 jours [Prénom]. À ce niveau, ça ne surprend plus — et c'est exactement ça le but.",
      "[Prénom], 7 jours consécutifs. La régularité à [N] séances se confirme semaine après semaine.",
      "7 jours de suite [Prénom]. Tu n'as plus besoin d'y réfléchir — tu y vas, c'est tout.",
    ],
    expert: [
      "[Prénom], 7 jours consécutifs. À [N] séances, cette régularité te définit.",
      "Streak 7 jours [Prénom]. L'ours reconnaît en toi quelqu'un qui ne s'arrête jamais vraiment.",
      "[Prénom], 7 jours de suite. Ce chiffre n'étonne plus personne — surtout pas toi.",
      "Une semaine sans interruption [Prénom]. À [N] entraînements, c'est une seconde nature.",
      "[Prénom], 7 séances d'affilée. La discipline à ton niveau n'est plus un effort — c'est un mode de vie.",
      "Streak 7 jours [Prénom]. [N] séances totales et tu continues d'empiler. L'ours admire.",
      "[Prénom], 7 jours consécutifs. Certains rêvent de cette constance — toi tu la vis depuis [N] séances.",
      "7 jours de suite [Prénom]. À ce niveau de régularité, tu appartiens à une catégorie rare.",
    ],
  },

  streak30Days: {
    debutant: [
      "[Prénom], 30 jours consécutifs. Ce n'est plus de la motivation, c'est une habitude.",
      "Un mois sans interruption [Prénom]. Tu fais partie de ceux qui tiennent vraiment.",
      "[Prénom], trente jours. Ce que tu construis depuis un mois commence à se voir.",
      "[Prénom], un mois sans s'arrêter. Ce n'est plus un effort, c'est qui tu es.",
      "30 jours consécutifs [Prénom]. L'entraînement fait partie de ta vie maintenant.",
      "[Prénom], trente jours. Beaucoup commencent, très peu tiennent un mois entier.",
      "Un mois [Prénom]. Ce que tu as construit en 30 jours ne s'efface pas facilement.",
      "30 jours sans interruption [Prénom]. Ton corps a changé, ta tête aussi.",
    ],
    avance: [
      "[Prénom], 30 jours consécutifs. À [N] séances, cette régularité n'est plus une surprise.",
      "Un mois sans s'arrêter [Prénom]. À ce stade de ta progression, tu sais ce que ça coûte vraiment.",
      "[Prénom], 30 jours d'affilée. La machine tourne, le corps répond, les résultats suivent.",
      "Streak 30 jours [Prénom]. À [N] entraînements, tenir un mois entier fait partie de qui tu es.",
      "[Prénom], un mois complet. Le mental et le physique avancent ensemble maintenant.",
      "30 jours sans interruption [Prénom]. À [N] séances au compteur, c'est une confirmation de plus.",
      "[Prénom], 30 jours consécutifs. La discipline à ce niveau se voit, se ressent et se mesure.",
      "Un mois entier [Prénom]. Tu maîtrises quelque chose que beaucoup cherchent sans jamais trouver.",
    ],
    expert: [
      "[Prénom], 30 jours consécutifs. À [N] séances, ce genre de streak impressionne toujours.",
      "Un mois sans s'arrêter [Prénom]. L'ours mesure ce que ça représente vraiment après [N] entraînements.",
      "[Prénom], 30 jours d'affilée. Tu n'es plus en train de construire une habitude — tu l'incarnes.",
      "Streak 30 jours [Prénom]. À [N] séances totales, ce chiffre s'ajoute à une légende personnelle.",
      "[Prénom], un mois complet encore. Ce niveau de discipline à [N] entraînements, c'est exceptionnel.",
      "30 jours consécutifs [Prénom]. L'ours s'incline devant cette constance qui ne faiblit jamais.",
      "[Prénom], 30 jours sans interruption. Après [N] séances, tu sais mieux que quiconque ce que ça vaut.",
      "Un mois entier [Prénom]. [N] entraînements au compteur et tu continues d'empiler les jours.",
    ],
  },

  // 14. Médailles — messages fixes par palier
  medals: {
    bronze:    "[Prénom], niveau 10 atteint — médaille Bronze débloquée. Les fondations sont posées.",
    argent:    "[Prénom], niveau 20 — médaille Argent. Tu n'es plus un débutant, et ça se voit.",
    or:        "[Prénom], niveau 30 — médaille Or. Tu fais partie de ceux qui s'accrochent vraiment.",
    diamant:   "[Prénom], niveau 40 — médaille Diamant. L'élite. Bienvenue dans une autre catégorie.",
    collector: "[Prénom], niveau 50 — Calestan Collector. La médaille des légendes. Tu en fais partie.",
  },

  // 15. Surcharge progressive (tonnage +5%)
  progressiveTonnage: {
    debutant: [
      "Impressionnant [Prénom], le tonnage grimpe. On continue comme ça.",
      "Tu deviens plus fort de séance en séance [Prénom]. Les chiffres le confirment.",
      "Ton tonnage grimpe [Prénom]. Le corps s'adapte, et ça se voit dans les chiffres.",
      "Plus lourd qu'avant [Prénom]. C'est exactement comme ça que la progression fonctionne.",
      "[Prénom], les chiffres ne mentent pas. Tu soulèves plus qu'à ta dernière séance.",
      "Tonnage en hausse [Prénom]. Chaque kilo de plus est une victoire concrète.",
      "[Prénom], +5% sur le tonnage. La régularité finit toujours par payer.",
      "Tu deviens plus fort [Prénom]. Séance après séance, les charges montent.",
      "[Prénom], progression visible sur le tonnage. Continue à pousser dans ce sens.",
      "Les chiffres confirment ce que tu ressens [Prénom]. Tu progresses.",
    ],
    avance: [
      "[Prénom], tonnage en hausse. Depuis ta première séance tu soulèves [X] fois plus.",
      "Ton tonnage grimpe encore [Prénom]. [N] séances de travail sérieux se voient dans les chiffres.",
      "[Prénom], [Tonnage_session] kg soulevés aujourd'hui. Ta première séance c'était [Tonnage_first] kg.",
      "Les charges montent [Prénom]. À [N] séances, la progression devient concrète et mesurable.",
      "[Prénom], tonnage en progression. Le corps répond exactement comme il devrait.",
      "Plus lourd que la dernière fois [Prénom]. C'est la définition exacte du progrès.",
      "[Prénom], les chiffres confirment ce que tu ressens. Séance après séance, tu deviens plus fort.",
      "Tonnage en hausse [Prénom]. À [N] entraînements, chaque progression supplémentaire se mérite.",
      "[Prénom], tu soulèves plus qu'à ta première séance. Beaucoup plus. C'est visible.",
      "Les charges progressent [Prénom]. [N] séances de constance produisent exactement ces résultats.",
    ],
    expert: [
      "[Prénom], depuis ta première séance tu as soulevé [Total_tonnage] tonnes au total. C'est colossal.",
      "Tonnage en hausse [Prénom]. [Tonnage_session] kg cette séance — ta première c'était [Tonnage_first] kg. Regarde le chemin.",
      "[Prénom], [X] fois plus lourd qu'au premier jour. Les chiffres racontent une histoire rare.",
      "Les charges montent encore [Prénom]. À [N] séances, chaque kilo de plus est une conquête.",
      "[Prénom], [Total_tonnage] tonnes soulevées au total. Ce chiffre représente des années de travail sérieux.",
      "Tonnage en progression [Prénom]. Après [N] entraînements, la force continue de croître — c'est exceptionnel.",
      "[Prénom], tu soulèves [X] fois plus qu'à tes débuts. L'ours mesure l'ampleur du chemin parcouru.",
      "Les données ne mentent pas [Prénom]. [Tonnage_session] kg aujourd'hui, [Tonnage_first] kg au départ.",
      "[Prénom], [Total_tonnage] tonnes au compteur. Peu d'athlètes atteignent ce volume sur la durée.",
      "Tonnage record [Prénom]. [N] séances de discipline produisent exactement ce genre de performance.",
    ],
  },

  // 16. Stagnation (4x même séance ±5%)
  stagnation: [
    "Pas de panique [Prénom], la progression n'est jamais linéaire. On assure la technique.",
    "Écoute ton corps [Prénom]. Une séance de maintien vaut mieux qu'une blessure.",
    "Même tonnage depuis 4 séances [Prénom]. Le corps s'est adapté, il faut lui donner un nouveau signal.",
    "[Prénom], même tonnage depuis quelques séances. Pense à changer le tempo ou les temps de repos.",
    "La progression n'est jamais linéaire [Prénom]. Parfois le corps a besoin de consolider avant d'avancer.",
    "[Prénom], les charges stagnent. Ça peut venir du sommeil, de l'alimentation ou du volume. Écoute ton corps.",
    "Même niveau depuis 4 séances [Prénom]. Essaie d'ajouter une série ou de réduire les temps de repos.",
    "[Prénom], quand les charges ne bougent plus, c'est souvent le moment de changer quelque chose — tempo, repos, ordre des exercices.",
    "Tonnage stable depuis quelques séances [Prénom]. Parfois le corps consolide avant de progresser.",
    "[Prénom], si les charges ne bougent plus, c'est peut-être l'heure de changer d'angle d'attaque.",
  ],

  // 17. Régularité (fallback)
  regularity: {
    debutant: [
      "La discipline bat la motivation [Prénom]. Bienvenue au club.",
      "La régularité est la clé de tous les gains [Prénom]. Continue comme ça.",
      "[Prénom], chaque séance compte. Même les plus ordinaires.",
      "On construit quelque chose [Prénom]. Séance après séance.",
      "[Prénom], les résultats sont la somme de tous les efforts invisibles.",
      "Pas besoin d'être motivé pour s'entraîner [Prénom]. Juste d'y aller.",
      "[Prénom], les meilleurs progrès se font dans la continuité. Tu es sur le bon chemin.",
      "Une journée de plus dans la construction [Prénom]. C'est tout ce qu'on demande.",
      "[Prénom], la constance fait ce que l'intensité ne peut pas faire seule.",
      "Tu reviens, tu travailles, tu progresses [Prénom]. Simple et efficace.",
    ],
    avance: [
      "[Prénom], [N] séances derrière toi. La progression n'est plus une question de si, mais de quand.",
      "Tu reviens encore [Prénom]. [N] entraînements — c'est ça qui sépare ceux qui progressent des autres.",
      "[Prénom], [N] séances. Le travail silencieux finit toujours par parler fort.",
      "La constance [Prénom]. [N] entraînements — c'est ton arme principale.",
      "[Prénom], tu es là encore. [N] séances — chaque présence compte.",
      "[N] entraînements [Prénom]. Tu as compris ce que beaucoup ne comprennent jamais.",
      "[Prénom], [N] séances. La régularité est la seule méthode qui ne ment jamais.",
      "Encore présent [Prénom]. [N] séances — la discipline se voit dans les chiffres.",
      "[Prénom], [N] entraînements. Le corps se souvient de chaque effort.",
      "Tu construis quelque chose de solide [Prénom]. [N] séances en sont la preuve.",
    ],
    expert: [
      "[Prénom], [N] séances. À ce niveau, l'entraînement fait partie de ton identité.",
      "[N] entraînements [Prénom]. L'ours reconnaît en toi quelqu'un qui ne s'arrête jamais.",
      "[Prénom], [N] séances. Les athlètes de ton calibre se comptent sur les doigts d'une main.",
      "Toujours là [Prénom]. [N] entraînements — une constance qui force le respect.",
      "[Prénom], [N] séances. Tu ne t'entraînes plus pour prouver quelque chose — tu t'entraînes parce que c'est qui tu es.",
      "[N] séances [Prénom]. Peu de gens comprennent ce que ça représente vraiment.",
      "[Prénom], [N] entraînements. L'ours est fier de partager cette route avec toi.",
      "Encore une séance [Prénom]. [N] au total — un chiffre qui raconte une histoire de discipline rare.",
      "[Prénom], [N] séances. Ce que tu as construit ne s'efface pas.",
      "[N] entraînements [Prénom]. Tu fais partie des rares qui comprennent vraiment ce que la régularité signifie.",
    ],
  },
};

// ------------------------------------------------------------
// LOGIQUE DE PRIORITÉ — Fonction principale
// ------------------------------------------------------------
/**
 * getMascotMessage(context) → { message: string, category: string }
 *
 * @param {Object} context
 * @param {string}  context.prenom
 * @param {boolean} context.isAbsoluteFirstLogin
 * @param {boolean} context.newMedalUnlocked
 * @param {string}  context.newMedalKey
 * @param {boolean} context.firstSessionEver
 * @param {boolean} context.newPR
 * @param {string}  context.prExercise
 * @param {boolean} context.weekCompleted
 * @param {boolean} context.tabataIncitation
 * @param {boolean} context.tabataBonusDone
 * @param {boolean} context.restDay
 * @param {boolean} context.tonnageUp5pct
 * @param {boolean} context.stagnation
 * @param {boolean} context.sessionDoneToday
 * @param {string}  context.sessionMuscleGroup
 * @param {number}  context.daysSinceLastSession
 * @param {boolean} context.isFirstConnectionOfWeek
 * @param {boolean} context.streak7
 * @param {boolean} context.streak30
 * @param {number}  context.sessionCount
 * @param {boolean} context.isPremium
 * @param {number}  context.firstSessionTonnage
 * @param {number}  context.lastSessionTonnage
 * @param {number}  context.totalTonnage
 * @param {boolean} context.isMissedSession    — Une séance du programme n'a pas été faite cette semaine
 * @param {string}  context.missedSessionName  — Nom de la séance manquée
 */
export function getMascotMessage(context) {
  const {
    prenom = "",
    isAbsoluteFirstLogin = false,
    newMedalUnlocked = false,
    newMedalKey = null,
    firstSessionEver = false,
    newPR = false,
    prExercise = "",
    weekCompleted = false,
    tabataIncitation = false,
    tabataBonusDone = false,
    restDay = false,
    tonnageUp5pct = false,
    stagnation = false,
    sessionDoneToday = false,
    sessionMuscleGroup = null,
    daysSinceLastSession = 0,
    isFirstConnectionOfWeek = false,
    streak7 = false,
    streak30 = false,
    sessionCount = 0,
    currentLevel = 1,
    firstSessionTonnage = 0,
    lastSessionTonnage = 0,
    totalTonnage = 0,
    isMissedSession = false,
    missedSessionName = "",
  } = context;

  // Détermination du niveau basé sur le niveau XP (indépendant du premium)
  const level = currentLevel >= 30 ? "expert"
    : currentLevel >= 10 ? "avance"
    : "debutant";

  // Variables dynamiques à injecter dans les messages
  const N = sessionCount;
  const X = firstSessionTonnage > 0 ? Math.round(lastSessionTonnage / firstSessionTonnage * 10) / 10 : "";
  const Tonnage_session = lastSessionTonnage > 0 ? Math.round(lastSessionTonnage).toLocaleString("fr-FR") + " kg" : "";
  const Tonnage_first = firstSessionTonnage > 0 ? Math.round(firstSessionTonnage).toLocaleString("fr-FR") + " kg" : "";
  const Total_tonnage = totalTonnage > 0 ? (Math.round(totalTonnage / 1000 * 10) / 10).toLocaleString("fr-FR") : "";
  const séance = missedSessionName;
  const dynVars = { N, X, Tonnage_session, Tonnage_first, Total_tonnage, séance };

  const resolve = (msg, exercice) => fmt(msg, prenom, exercice, dynVars);

  const byLevel = (cat) => {
    if (level === "expert" && cat.expert) return pick(cat.expert);
    if (level === "avance" && cat.avance) return pick(cat.avance);
    return pick(cat.debutant || cat);
  };

  // ── PRIORITÉ 1 : Tabata incitation
  if (tabataIncitation) return { category: "tabataIncitation", message: resolve(pick(MASCOT_MESSAGES.tabataIncitation)) };

  // ── PRIORITÉ 2 : Première connexion absolue
  if (isAbsoluteFirstLogin) return { category: "firstConnectionEver", message: resolve(MASCOT_MESSAGES.firstConnectionEver[0]) };

  // ── PRIORITÉ 3 : Nouvelle médaille
  if (newMedalUnlocked && newMedalKey && MASCOT_MESSAGES.medals[newMedalKey]) return { category: "medal", message: resolve(MASCOT_MESSAGES.medals[newMedalKey]) };

  // ── PRIORITÉ 4 : Première séance ever
  if (firstSessionEver) return { category: "firstSessionEver", message: resolve(pick(MASCOT_MESSAGES.firstSessionEver)) };

  // ── PRIORITÉ 5 : Nouveau PR
  if (newPR) return { category: "newPR", message: resolve(byLevel(MASCOT_MESSAGES.newPR), prExercise) };

  // ── PRIORITÉ 6 : Semaine complétée
  if (weekCompleted) return { category: "weekCompleted", message: resolve(byLevel(MASCOT_MESSAGES.weekCompleted)) };

  // ── PRIORITÉ 6.5a : Tabata bonus validé
  if (tabataBonusDone) return { category: "tabataBonusDone", message: resolve(pick(MASCOT_MESSAGES.tabataBonusDone)) };

  // ── PRIORITÉ 6.5a-bis : Jour de repos
  if (restDay) return { category: "restDay", message: resolve(pick(MASCOT_MESSAGES.restDay)) };

  // ── PRIORITÉ 6.5b : Séance sautée détectée (seulement si séance pas faite aujourd'hui)
  if (isMissedSession && missedSessionName && !sessionDoneToday) return { category: "missedSession", message: resolve(pick(MASCOT_MESSAGES.missedSession)) };

  // ── PRIORITÉ 6.5c : Séance terminée → messages post-séance en priorité
  if (sessionDoneToday) {
    if (tonnageUp5pct) return { category: "progressiveTonnage", message: resolve(byLevel(MASCOT_MESSAGES.progressiveTonnage)) };
    if (stagnation) return { category: "stagnation", message: resolve(pick(MASCOT_MESSAGES.stagnation)) };
    return { category: "sessionDone", message: resolve(byLevel(MASCOT_MESSAGES.sessionDone)) };
  }

  // ── PRIORITÉ 7 : Avant séance — message du muscle à venir
  if (sessionMuscleGroup && MASCOT_MESSAGES.sessionOfDay[sessionMuscleGroup]) {
    const grp = MASCOT_MESSAGES.sessionOfDay[sessionMuscleGroup];
    return { category: "sessionOfDay", message: resolve(byLevel(grp)) };
  }

  // ── STREAK 30j
  if (streak30) return { category: "streak30", message: resolve(byLevel(MASCOT_MESSAGES.streak30Days)) };

  // ── STREAK 7j
  if (streak7) return { category: "streak7", message: resolve(byLevel(MASCOT_MESSAGES.streak7Days)) };

  // ── Retour après absence > 7 jours
  if (daysSinceLastSession > 7) return { category: "returnAfter1Week", message: resolve(byLevel(MASCOT_MESSAGES.returnAfter1Week)) };

  // ── Retour après 5-7 jours
  if (daysSinceLastSession >= 5 && daysSinceLastSession <= 7) return { category: "returnAfter5to7Days", message: resolve(byLevel(MASCOT_MESSAGES.returnAfter5to7Days)) };

  // ── Retour après 2-4 jours
  if (daysSinceLastSession >= 2 && daysSinceLastSession <= 4) return { category: "returnAfter2to4Days", message: resolve(byLevel(MASCOT_MESSAGES.returnAfter2to4Days)) };

  // ── Première connexion de la semaine
  if (isFirstConnectionOfWeek) return { category: "firstConnectionOfWeek", message: resolve(byLevel(MASCOT_MESSAGES.firstConnectionOfWeek)) };

  // ── Fallback : régularité
  return { category: "regularity", message: resolve(byLevel(MASCOT_MESSAGES.regularity)) };
}
